<div>
  <div class="login-page">
    <div class="login-container">
      <!-- Login Left Side Section Code Start -->
      <div class="login-form-container" role="main">
        <span class="notification-login-message"><b>{{this.showNotification()}}</b></span>
        <h1 class="heading-level-1 gray-color margin-0 mb-5">Welcome to</h1>
        <span *ngIf="resetPasswordSuccessMessage" class="reset-password-login-message"><b>{{ resetPasswordSuccessMessage }}</b></span>
        <div class="logo" role="banner" tabindex="0">
          <img src="assets/images/logo.svg" aria-label="BankExec Logo" alt="Logo" />
        </div>

        <!-- Login Form Code Start -->
        <form role="presentation" class="form-style1" #courseForm="ngForm" (ngSubmit)="submit()" [hidden]="!showform">
          <div class="form-group">
            <input type="email" id="email" name="email" placeholder=" "
              title=""
              [(ngModel)]="email"
              (change)="onEmailBlur()"
              required>
            <label for="email">Email</label>
            <img class="icon" style="cursor: auto;" src="assets/images/mail_icon.svg" alt="Mail" />
          </div>

          <div class="form-group">
            <input type="password" id="sign_in_password" name="password" placeholder=""
              title=""
              aria-label="Password"
              [(ngModel)]="password"
              required>
            <label for="password">Password</label>
            <img class="icon eye_img" tabindex="0" aria-label="Toggle Password Visibility" src="assets/images/eye_password.svg" alt=""
              (click)="revealPassword('sign_in_password')" />
          </div>

          <div class="terms-field">
            <input type="checkbox" aria-label="Terms and Conditions" title="Terms and Conditions" [disabled]="disable_terms" [(ngModel)]="terms_chkbox">
            <p>I agree to the <a href="assets/images/License Agreement.pdf" target="_blank">Terms and Conditions</a>.</p>
          </div>
          <div class="button-container">
            <button type="submit" [disabled]="disable_login" class="button-style1 width-135">Login</button>
            <a href="https://content.aba.com/bankexec/files/BE_LoginforBankExec.mp4"
               target="_blank" rel="noopener"
               class="button-style1 width-135 login-help-btn"
               aria-label="Login Help Video">
              <span class="play-icon">&#9654;</span> Login Help
            </a>
          </div>
          <div *ngIf="errorMsg" class="errormsg" role="alert">
            {{errorMsg}}
          </div>

          <div class="forgot-password-field">
            <a (click)="forgotpassword()" (keydown.enter)="forgotpassword()" tabindex="0" aria-label="Forgot your password?">Forgot password?</a>
          </div>
        </form>
        <!-- Login Form Code End -->

        <div class="login-bottom-section" aria-label="contentinfo">
          <img src="assets/images/ABA-logo.png" alt="ABA Logo" aria-label="Footer Logo" />
          <p>© {{ currentYearCopyRight }} American Bankers Association</p>
        </div>
      </div>
      <!-- Login Left Side Section Code End -->

      <!-- Login Right Side Image Section Code Start -->
      <div class="login-image-container">
        <img class="login-banner" src="assets/images/login-right.webp" alt="Login" />
        <!-- <a href="{{ demoLink }}" target="_blank" role="button" class="watch-demo-button absolute-auto font-style3"><img src="assets/images/watch.svg" alt="" /> <span>Watch a Demo</span></a> -->
      </div>
      <!-- Login Right Side Image Section Code End -->
    </div>
  </div>
  <!-- Footer Links Section Start -->
  <footer class="login-footer-links">
    <hr class="footer-divider" />
    <div class="footer-link-row">
      <a href="https://content.aba.com/support/tools/bankexecsyscheck_v3/index.html" target="_blank" rel="noopener" aria-label="System Check">System Check</a>
      <span class="footer-separator">|</span>
      <a href="https://content.aba.com/support/docs/ABABANKEXEC_tech_specs_FINAL_May_2025.pdf" target="_blank" rel="noopener" aria-label="Technical Specifications">Technical Specifications</a>
      <span class="footer-separator">|</span>
      <a href="https://content.aba.com/support/tools/BankExecHelp_v3/FAQ.html?Student" target="_blank" rel="noopener" aria-label="FAQs">FAQ</a>
      <span class="footer-separator">|</span>
      <a href="https://content.aba.com/support/tools/BankExecHelp/contact.aspx" target="_blank" rel="noopener" aria-label="Get Help">Get Help</a>
    </div>
  </footer>
  <!-- Footer Links Section End -->
</div>
